import {calculateSizeWithRatio, SizeWithRatioParams} from './size-with-ratio';
import {VideoPositioningStrategy, VideoSizeResult} from './abstractions';

export class StretchedVideoStrategy extends VideoPositioningStrategy {
    constructor(annotationCanvas, window) {
        super();

        this._annotationCanvas = annotationCanvas;
        this._window = window;
    }

    getVideoNewSize(videoMeta) {
        const {maxWidth, maxHeight} = this._getSizeLimits();
        const calcParams = new SizeWithRatioParams(maxWidth, maxHeight, videoMeta.isPortrait, videoMeta.aspectRatio);
        const {newWidth, newHeight} = calculateSizeWithRatio(calcParams);
        const newSize = new VideoSizeResult(newWidth, newHeight);

        return newSize;
    }

    updateVideoSize(elVideo, videoNewSize, videoMeta) {
        super.updateVideoSize(elVideo, videoNewSize, videoMeta);

        // Get the canvas element (could be HTMLElement or jQuery-like object)
        const canvas =
            this._annotationCanvas instanceof HTMLElement
                ? this._annotationCanvas
                : this._annotationCanvas && this._annotationCanvas[0];

        if (canvas) {
            canvas.width = videoMeta.streamWidth;
            canvas.height = videoMeta.streamHeight;
            canvas.style.width = `${videoNewSize.width}px`;
            canvas.style.height = `${videoNewSize.height}px`;
            canvas.style.marginLeft = '0';
        }
    }

    updateVideoLocation(videoSize, elContainer, videoWasManuallyMoved) {
        super.updateVideoLocation(videoSize, elContainer, videoWasManuallyMoved);

        const element = elContainer instanceof HTMLElement ? elContainer : elContainer[0];

        if (element) {
            element.style.left = '0';
            element.style.right = 'auto';
            element.style.top = '0';
            element.style.bottom = 'auto';
            element.style.display = '';
            element.style.width = '';
        }
    }

    _getSizeLimits() {
        const mainContainer = document.querySelector('.dashboard-main-content-container');

        return {
            maxWidth: this._getMaxWidth(mainContainer),
            maxHeight: this._getMaxHeight(mainContainer)
        };
    }

    _getMaxHeight(mainContainer) {
        const oldFooter = document.querySelector('.dashboard-bottom-bar');
        const topBar = document.querySelector('.app-top-bar');
        const windowHeight = this._window.innerHeight;
        const topBarHeight = topBar ? 90 : 10;
        const bottomBarHeight = oldFooter ? 55 : 0;

        let mainContainerPadding = 0;
        let paddingTop = 0;
        if (mainContainer) {
            const computedStyle = window.getComputedStyle(mainContainer);
            mainContainerPadding = parseInt(computedStyle.paddingBottom, 10) || 0;
            paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        }

        let result = windowHeight - topBarHeight - bottomBarHeight - mainContainerPadding;

        if (mainContainer) {
            const rect = mainContainer.getBoundingClientRect();
            const availableHeight = rect.height - paddingTop - mainContainerPadding;
            result = Math.min(result, availableHeight);
        }

        return result;
    }

    _getMaxWidth(mainContainer) {
        if (!mainContainer) {
            return this._window.innerWidth;
        }
        return mainContainer.getBoundingClientRect().width;
    }
}
